module.exports = __webpack_public_path__ + "static/media/CTLA_5-286w.2062733d.webp";